<template>
  <div class="d-flex flex-column notification__wrap">
    <vis-toolbar :items="toolbar"></vis-toolbar>
    <!--<vis-loading :loading="loading">-->
    <div class="flex-grow-1">
      <b-list-group class="overflow-auto notification__content">
        <b-list-group-item @dblclick="openDetailView(item)" class="notification" v-for="item in dataItems"
                           :key="item.ID" @click="selectItem(item)">
          <small class="notification__time mb-1 d-block">
            <time :datatime="item.Date">{{ item.Date | formatDate }}</time>
          </small>
          <div class="notification__body row align-items-start flex-nowrap m-0">
            <div>
              <b-checkbox @click.native.prevent.stop="onSelect(item, $event)" v-model="item.selected"></b-checkbox>
            </div>
            <div>
              <strong class="mb-1 d-block">{{item.Title}}</strong>
              <small>{{ truncate(item.Description, 50) }}</small>
            </div>
          </div>
        </b-list-group-item>
      </b-list-group>
      <b-pagination-nav base-url="#" :number-of-pages="numberOfPages" class="w-100 border-top d-flex align-items-center justify-content-center notification__pagination"
                    :per-page="pageSize" v-model="currentPage"></b-pagination-nav>
    </div>
    <!--</vis-loading>-->
    <vis-confirm-dialog
      :visible="confirmDialogVisible"
      :title="$t('notification.confirmTitle')"
      :text="$t('notification.confirmText')"
      @acceptChanges="markAllAsRead"
      @cancelChanges="confirmDialogVisible = false"
      @hideDialog="confirmDialogVisible = false"
    ></vis-confirm-dialog>
    <vis-modal size="lg" v-if="notification" :title="$t('toast')" :visible="detailViewVisible" @hide="closeDetailView">
      <div class="d-flex mb-3 align-items-center">
        <label class="col-3">{{$t('date')}}</label>
        <div class="col-9">{{ notification.Date | formatDate }}</div>
      </div>
      <div class="d-flex mb-3 align-items-center">
        <label class="col-3">{{$t('title')}}</label>
        <div class="col-9">{{notification.Title}}</div>
      </div>
      <div class="d-flex mb-3 align-items-center">
        <label class="col-3">{{$t('description')}}</label>
        <div class="col-9">{{notification.Description}}</div>
      </div>
      <div class="d-flex align-items-center" v-if="objectViewConfig">
        <label class="col-3">{{$t('object')}}</label>
        <div class="col-9"><b-button variant="primary" @click="openObjectDetailView">{{ objectViewConfig.Title }}</b-button></div>
      </div>
    </vis-modal>
  </div>
</template>

<script>
  import {formatDateTime} from "@/shared/date";
  import visaryApi from '@/api/visary-api'
  import api from "@/api/notification-api";
  import VisDetailViewDialog from "@/views/base/common/vis-detail-view-dialog";
  import eventBus from "@/shared/global-events";
  import { VisGlobalEventTypes } from '@/shared/enum/global-event-types'
  import errorMessage from "@/shared/error-message";
  import Vue from "vue";
  import router from "@/router";
  import i18n from "@/shared/i18n";
  import RemoteCrudService from "@/shared/services/remote-crud-service";
  import { truncate } from "@/filters/string";

  export default {
    name: "vis-notifications",
    props: {
      visible: {
        type: Boolean,
        default: false
      },
    },
    data() {
      const vm = this;
      return {
        dataItems: [],
        total: 0,
        pageSize: 50,
        currentPage: 1,
        active: 0,
        detailViewVisible: false,
        objectViewConfig: null,
        objectMnemonic: '',
        objectId: 0,
        notification: null,
        loading: true,
        confirmDialogVisible: false,
        toolbar: [
          {
            type: 'button-group',
            buttons: [
              {
                id: 'shownotification',
                icon: 'far fa-eye',
                title: this.$t('notification.showNotification'),
                order: 0,
                onClick() {
                  const item = vm.dataItems.find(x => x.ID === vm.active);
                  if (item) {
                    vm.openDetailView(item);
                  }
                }
              },
              {
                id: 'markasread',
                icon: 'far fa-check',
                title: this.$t('notification.markAsRead'),
                order: 1,
                async onClick() {
                  const selected = vm.dataItems.filter(x => x.selected).map(x => x.ID);
                  if (selected.length > 0) {
                    await vm.markAsRead(selected)
                  }
                }
              },
              {
                id: 'markallasread',
                icon: 'far fa-check-square',
                title: this.$t('notification.markAllAsRead'),
                order: 2,
                onClick() {
                  if (vm.dataItems.length > 0) {
                    vm.confirmDialogVisible = true;
                  }
                }
              },
              {
                id: 'refresh',
                icon: 'far fa-refresh',
                title: this.$t('refresh'),
                order: 3,
                async onClick() {
                  await vm.dataBind();
                }
              },
            ]
          }
        ],
      }
    },
    methods: {
      async dataBind() {
        try {
          this.loading = true;
          if (this.visible) {

            let response = await api.notification.getAll(this.currentPage, this.pageSize)

            let data = response.Data.map(x => Object.assign(x, {selected: false}));
            this.$set(this, 'dataItems', data);
            this.total = response.Total
          }
        } catch (e) {
          this.$visNotification.error(errorMessage(e).message)
        } finally {
          this.loading = false;
        }
      },
      async markAllAsRead() {

        try {
          this.loading = true;
          await api.notification.markAllAsRead();
          await this.dataBind();
          eventBus.emit(VisGlobalEventTypes.GET_CURRENT_NOTIFICATION_COUNT);
          this.confirmDialogVisible = false;
        } catch (e) {
          this.$visNotification.error((await errorMessage(e)).message)
        } finally {
          this.loading = false;
        }
      },
      onSelect(item) {
        this.$set(item, 'selected', !item.selected);
        this.active = item.ID;
      },
      async openDetailView(item) {
        this.notification = await api.notification.get(item.ID);
        this.objectId = item.ID;

        try {
          this.objectMnemonic = await visaryApi.viewConfig.getMnemonicByType(item.Entity.TypeName);
          this.objectViewConfig = await visaryApi.viewConfig.getDetailView(this.objectMnemonic);
        } finally {
          this.detailViewVisible = true
        }
      },
      selectItem(item) {
        this.$set(this, 'dataItems', this.dataItems.map(x => Object.assign(x, {selected: false})));
        this.active = item.ID;
        item.selected = true;
      },
      async markAsRead(ids) {
        try {
          this.loading = true;
          await api.notification.markAsRead(ids);
          this.$set(this, 'dataItems', this.dataItems.filter(x => ids.indexOf(x.ID) === -1));
          eventBus.emit(VisGlobalEventTypes.GET_CURRENT_NOTIFICATION_COUNT);
        } finally {
          this.loading = false;
        }
      },
      openObjectDetailView() {
        if (!this.notification && !this.objectMnemonic)
          return;

        const crudService = new RemoteCrudService(this.objectMnemonic)
        crudService.setId(this.notification.Entity.ObjectID)

        const component = new Vue(
          Vue.util.extend(
            { router, i18n },
            {
              render(h) {
                const self = this;
                return h(VisDetailViewDialog, {
                  props: {
                    visible: true,
                    crudService: crudService
                  },
                  on: {
                    close() {
                      self.$destroy();
                    }
                  }
                });
              }
            }
          )
        ).$mount();

        document.body.appendChild(component.$el);
      },
      async closeDetailView() {
        this.notification = null;
        this.objectViewConfig = null
        this.objectMnemonic = '';
        if (this.objectId !== 0) {
          await this.markAsRead([this.objectId])
          this.objectId = 0;
        }
      },
      truncate(value, length) {
        return truncate(value, length)
      }
    },
    computed: {
      numberOfPages() {
        const total = Math.ceil(this.total / this.pageSize);
        return total > 0 ? total : 1;
      }
    },
    watch: {
      visible: {
        async handler(val) {
          if (val) {
            await this.dataBind();
          }
        },
        immediate: true
      },
      async currentPage() {
        await this.dataBind();
      }
    },
    filters: {
      formatDate(val) {
        return formatDateTime(val)
      }
    },
    mounted() {
      eventBus.on('getCurrentNotifications', this.dataBind)
    },
    beforeDestroy() {
      eventBus.off('getCurrentNotifications', this.dataBind);
    }
  }
</script>
